import React, { useContext, useEffect, useState } from 'react';
import { Modal, Select, Button, Typography, message, Spin, Alert } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { AuthContext } from '../../../config/AuthContext';
import { GetUserAules } from '../../../dao/abp/GetUserAules';
import { PostProjecteDuplicar } from '../../../dao/abp/PostProjecteDuplicar';

const { Text } = Typography;

interface Props {
    projecte: any;          // { id, nom }
    visible: boolean;
    onClose: (reload: boolean) => void;
}

const ProjecteDuplicarModal: React.FC<Props> = ({ projecte, visible, onClose }) => {
    const { userId } = useContext(AuthContext);
    const [aules, setAules] = useState<any[]>([]);
    const [selectedAula, setSelectedAula] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [loadingAules, setLoadingAules] = useState(false);

    useEffect(() => {
        if (visible) {
            loadAules();
            setSelectedAula(undefined);
        }
    }, [visible]);

    async function loadAules() {
        setLoadingAules(true);
        const data = await GetUserAules(userId);
        setAules(Array.isArray(data) ? data : []);
        setLoadingAules(false);
    }

    async function handleDuplicar() {
        if (!selectedAula) {
            message.warning('Selecciona una aula de destí');
            return;
        }
        setLoading(true);
        const ok = await PostProjecteDuplicar(projecte.id + '', selectedAula, userId);
        setLoading(false);
        if (ok) {
            message.success(`Projecte "${projecte.nom}" duplicat correctament!`);
            onClose(true);
        } else {
            message.error('Error en duplicar el projecte. Torna-ho a intentar.');
        }
    }

    return (
        <Modal
            title={
                <span>
                    <CopyOutlined style={{ marginRight: 8, color: '#722ed1' }} />
                    Duplicar projecte a una altra aula
                </span>
            }
            open={visible}
            onCancel={() => onClose(false)}
            footer={[
                <Button key="cancel" onClick={() => onClose(false)}>
                    Cancel·lar
                </Button>,
                <Button
                    key="duplicar"
                    type="primary"
                    icon={<CopyOutlined />}
                    loading={loading}
                    disabled={!selectedAula}
                    onClick={handleDuplicar}
                    style={{ backgroundColor: '#722ed1', borderColor: '#722ed1' }}
                >
                    Duplicar
                </Button>
            ]}
            width={480}
            destroyOnClose
        >
            <div style={{ padding: '8px 0' }}>
                <Alert
                    type="info"
                    showIcon
                    style={{ marginBottom: 20 }}
                    message={
                        <span>
                            Es crearà una còpia de <strong>"{projecte?.nom}"</strong> a l'aula seleccionada,
                            incloent totes les tasques sense assignació de RA i els documents.
                        </span>
                    }
                />

                <div style={{ marginBottom: 8 }}>
                    <Text strong>Aula de destí:</Text>
                </div>

                <Spin spinning={loadingAules}>
                    <Select
                        style={{ width: '100%' }}
                        placeholder="Selecciona una aula..."
                        value={selectedAula}
                        onChange={setSelectedAula}
                        showSearch
                        filterOption={(input, option) =>
                            (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                        }
                        options={aules.map((a: any) => ({
                            value: a.id + '',
                            label: `${a.nom}${a.codi ? ` (${a.codi})` : ''}`
                        }))}
                    />
                </Spin>
            </div>
        </Modal>
    );
};

export default ProjecteDuplicarModal;
